import request from '@/utils/request'
import env from '@/env'
export function sendEmail (params: any) {
    return request({
        url: env.testUrlWeb + '/tool/contactMail',
        method: 'POST',
        data: params,
    })
}
export function getProductDetail (params: any) {
    return request({
        url: env.testUrlWeb + '/tool/productConsultationMail',
        method: 'POST',
        data: params,
    })
}